import { render, staticRenderFns } from "./relevancyTabAPP.vue?vue&type=template&id=fc237ee4&scoped=true&"
import script from "./relevancyTabAPP.vue?vue&type=script&lang=js&"
export * from "./relevancyTabAPP.vue?vue&type=script&lang=js&"
import style0 from "./relevancyTabAPP.vue?vue&type=style&index=0&id=fc237ee4&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc237ee4",
  null
  
)

export default component.exports